import React from 'react'
import { connect } from 'redaction'
import actions from 'redux/actions'
import { compose, constants, links, snowplow } from 'common/helpers'

import injectGlobals from 'decorators/injectGlobals'

import FooterView from 'common/components/layout/Footer/FooterView/FooterView'

import makeupData from 'common/components/layout/Footer/data/makeup'
import defaultData from 'common/components/layout/Footer/data/default'

import FooterCollectEmailForm from './FooterCollectEmailForm/FooterCollectEmailForm'

import messages from './messages'

// eslint-disable-next-line
import iconUpgrade from 'components/buttons/UpgradeButton/images/icon-upgrade-white.svg'


const Footer = (props) => {
  const {
    logoLink, isLoggedIn, isGoogleBot, isMakeupLandingPage,
    subscription: { isSubscribed, isUpgradable, currPlan: { billingPeriod } },
  } = props

  let data = { ...(isMakeupLandingPage ? makeupData : defaultData), logoLink }

  // billingPeriod !== 12 condition from SCNT-1614
  if (isSubscribed && isUpgradable && billingPeriod !== 12) {
    data = {
      ...defaultData,
      shop: {
        ...defaultData.shop,
        nav: [
          ...defaultData.shop.nav,
          {
            title: messages.upgradeYourPlan,
            icon: iconUpgrade,
            onClick: () => {
              snowplow.track(constants.snowplowEvents.upgradeSubscriptionClick, { placement: 'footer' }, false)
              actions.models.subscription.handleUpgradeClick({
                placement: 'footer',
                mixpanelEvent: {
                  name: constants.analyticsEvents.upgradePopup,
                  placement: 'footer',
                },
              })
            },
          },
        ],
      },
    }
  }

  const emailFormNode = (
    <FooterCollectEmailForm />
  )

  return (
    <FooterView
      data={data}
      collectEmailFormNode={emailFormNode}
      isAddressVisible={isGoogleBot && !isLoggedIn}
    />
  )
}


export default compose(
  injectGlobals(({ getFeatureToggle, globals }) => ({
    isGoogleBot: globals.device.isBot && getFeatureToggle(constants.features.isGoogleBot),
  })),
  connect({
    logoLink: (state) => {
      const { models: { me: { gender, isLoggedIn } } } = state

      if (!isLoggedIn) {
        return links.home
      }

      return gender === 'female' ? links.subscription.mainWomen : links.subscription.mainMen
    },
    subscription: 'models.subscription',
    isLoggedIn: 'models.me.isLoggedIn',
  }),
)(Footer)
